export enum AttrDataTypeEnum {
    tag = 0,
    range = 1,
    multiple = 2
}
